import { render, staticRenderFns } from "./tproduct-add-or-update.vue?vue&type=template&id=399cef6e&"
import script from "./tproduct-add-or-update.vue?vue&type=script&lang=js&"
export * from "./tproduct-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports